import {SDKEventAttrs} from '@mparticle/web-sdk';
import {InView} from 'react-intersection-observer';
import {trackEvent} from '../../utils/mParticleTracking';

export const TrackOnView = ({
  eventName,
  eventAttributes,
  threshold = 0.33,
  children,
}: {
  eventName: string;
  eventAttributes: SDKEventAttrs;
  threshold?: number;
  children: React.ReactNode;
}) => {
  const trackComponentInView = (inView: boolean) => {
    if (inView) {
      trackEvent({
        eventName,
        eventAttributes,
      });
    }
  };

  return (
    <InView onChange={trackComponentInView} threshold={threshold} triggerOnce>
      {children}
    </InView>
  );
};
